import { useState } from 'react';

export default function WagerCalculator() {
  const [bonusAmount, setBonusAmount] = useState('');
  const [wager, setWager] = useState('30');
  const [betSize, setBetSize] = useState('');
  const [result, setResult] = useState<{
    totalWager: number;
    betsNeeded: number;
    estimatedTime: number;
  } | null>(null);
  const [showResult, setShowResult] = useState(false);

  const calculate = () => {
    const bonus = parseFloat(bonusAmount);
    const wagerMultiplier = parseFloat(wager);
    const bet = parseFloat(betSize);

    if (bonus && wagerMultiplier && bet) {
      const totalWager = bonus * wagerMultiplier;
      const betsNeeded = Math.ceil(totalWager / bet);
      const estimatedTime = Math.ceil(betsNeeded * 2 / 60);

      setResult({ totalWager, betsNeeded, estimatedTime });
      setShowResult(true);
    }
  };

  return (
    <section className="py-20 px-4 bg-gradient-to-r from-[#1a1a1f] via-[#242429] to-[#1a1a1f]">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12 animate-on-scroll opacity-0">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Калькулятор отыгрыша бонусов</h2>
          <p className="text-gray-400">Рассчитайте, сколько нужно поставить для отыгрыша вейджера</p>
        </div>

        <div className="bg-[#242429] rounded-3xl p-8 border-2 border-[#d4af37] shadow-2xl shadow-[#d4af37]/20 animate-on-scroll opacity-0">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 bg-gradient-to-br from-[#d4af37] to-[#f4d03f] rounded-full flex items-center justify-center">
              <i className="ri-calculator-line text-2xl text-black"></i>
            </div>
            <h3 className="text-2xl font-bold">Калькулятор вейджера</h3>
          </div>

          <div className="space-y-6 mb-8">
            <div>
              <label className="block text-gray-400 mb-2 flex items-center gap-2">
                <i className="ri-money-dollar-circle-line text-[#d4af37]"></i>
                Сумма бонуса (₽)
              </label>
              <input
                type="number"
                value={bonusAmount}
                onChange={(e) => setBonusAmount(e.target.value)}
                placeholder="Например: 10000"
                className="w-full bg-[#1a1a1f] border border-gray-700 rounded-xl px-4 py-3 text-white focus:border-[#d4af37] focus:outline-none transition-colors"
              />
            </div>

            <div>
              <label className="block text-gray-400 mb-2 flex items-center gap-2">
                <i className="ri-repeat-line text-[#d4af37]"></i>
                Размер вейджера (x)
              </label>
              <select
                value={wager}
                onChange={(e) => setWager(e.target.value)}
                className="w-full bg-[#1a1a1f] border border-gray-700 rounded-xl px-4 py-3 text-white focus:border-[#d4af37] focus:outline-none transition-colors cursor-pointer"
              >
                <option value="20">x20</option>
                <option value="25">x25</option>
                <option value="30">x30</option>
                <option value="35">x35</option>
                <option value="40">x40</option>
                <option value="50">x50</option>
              </select>
            </div>

            <div>
              <label className="block text-gray-400 mb-2 flex items-center gap-2">
                <i className="ri-coin-line text-[#d4af37]"></i>
                Ваша ставка за игру (₽)
              </label>
              <input
                type="number"
                value={betSize}
                onChange={(e) => setBetSize(e.target.value)}
                placeholder="Например: 100"
                className="w-full bg-[#1a1a1f] border border-gray-700 rounded-xl px-4 py-3 text-white focus:border-[#d4af37] focus:outline-none transition-colors"
              />
            </div>
          </div>

          <button
            onClick={calculate}
            className="w-full bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black font-bold py-4 px-6 rounded-full hover:shadow-lg hover:shadow-[#d4af37]/50 transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap"
          >
            <i className="ri-calculator-line text-xl"></i>
            Рассчитать
          </button>

          {showResult && result && (
            <div className="mt-8 bg-gradient-to-br from-[#1a1a1f] to-[#242429] rounded-2xl p-6 border border-[#d4af37] animate-fade-in">
              <h4 className="text-xl font-bold mb-4 text-[#d4af37]">Результаты расчета:</h4>
              <div className="space-y-4">
                <div className="flex justify-between items-center pb-3 border-b border-gray-700">
                  <span className="text-gray-400">Сумма для отыгрыша:</span>
                  <span className="text-3xl font-bold text-white">{result.totalWager.toLocaleString()}₽</span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b border-gray-700">
                  <span className="text-gray-400">Количество ставок:</span>
                  <span className="text-2xl font-bold text-[#2ecc71]">{result.betsNeeded.toLocaleString()}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-400">Примерное время:</span>
                  <span className="text-2xl font-bold text-[#d4af37]">~{result.estimatedTime}ч</span>
                </div>
              </div>
              <div className="mt-4 p-4 bg-[#d4af37]/10 rounded-xl">
                <p className="text-sm text-gray-300">
                  <i className="ri-information-line text-[#d4af37] mr-2"></i>
                  Расчет приблизительный. Время указано из расчета 2 минуты на ставку.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}